export const SUCCESS_STATUS_CODES = new Set([200, 201, 202, 204]);
